import { currency } from '@theme/utilities';


const parent_blocks = document.querySelectorAll(".hdt-custom-subscription-box .purchase_option");
parent_blocks.forEach(function (parent_block) {    
  parent_block.addEventListener('click', function() {
    
    //  parent_block?.closest(".hdt-custom-subscription-box")
    //   .querySelectorAll(".hdt-custom-sub-option")
    //   .forEach(el => el.classList.remove("active"));
    
      // parent_block?.closest(".hdt-custom-sub-option")?.classList.add("active");      
    const parent_form = parent_block?.closest(".content-for-layout");      
    const plusBtn = parent_form?.querySelector(".hdt-quantity__button.no-js-hidden[name='plus']");    
    const minusBtn = parent_form?.querySelector(".hdt-quantity__button.no-js-hidden[name='minus']");    
    const qtyInput = parent_form?.querySelector(".hdt-quantity__input");    
    const get_total_price = parent_block?.getAttribute("data-total-price");
     const product_price = parent_block?.getAttribute("data-product-price");    
    const get_unit_price = parent_block?.getAttribute("data-unit-price") | null;    
    const price_set = document.querySelectorAll(".main_price");    
    const qty = parseInt(qtyInput?.value, 10);
    const plan = parseInt(parent_block?.dataset.planSub, 10);    
    const selling_plan = document.querySelector("[data-selling-plan]");            

    const is_sticky = parent_block?.closest(".custom-subscription-dropdown") || null;
    if(is_sticky != null){      
       const isOpen = is_sticky.classList.toggle('open');
       const dropdown = is_sticky?.querySelector(".custom-subscription-dropdown__toggle span") || null;
      //  console.log("dropdown..",dropdown);
       const get_plan_selected = parent_block.getAttribute("data-plan");     
       dropdown.setAttribute("data-selected-plan",get_plan_selected);
    }
      console.log("plan dynamic",plan);

      const product_qty_price = product_price * qty;  
    if(plan === 3 && get_unit_price != null) {
      // const product_qty_price = product_price * 1;  
      console.log("get_total_price dynamic",get_total_price)
      // const qty_price = get_total_price * 1;  
      const qty_price = get_total_price * qty;       

      // console.log("qty_price dynamic",qty_price)
      const set_total_price = document.querySelectorAll(".discount_price");
       set_total_price?.forEach(el => {
         el.closest(".discount_wrapp")?.classList.remove("hide");
          console.log("product_price",product_price,product_qty_price,"get_total_price",get_total_price,qty_price)
          if(product_qty_price == qty_price){
            el.closest(".discount_wrapp")?.classList.add("hide");
          }
          
        el.innerHTML="";
        el.innerHTML = `${currency.formatMoney(product_qty_price)}`;
      });                  
      
       price_set?.forEach(el => {
        el.innerHTML=""
        el.innerHTML=`${currency.formatMoney(qty_price)}`;          
      });
      if(qty % 2 === 0){  
          console.log("qty...module",qty);  
          // minusBtn?.click();
      } 

      // set_total_price.innerHTML="";
      // set_total_price.innerHTML= `${currency.formatMoney(get_total_price)}`;
      
      // price_set.innerHTML=""
      // price_set.innerHTML=`${currency.formatMoney(qty_price)}`;        
      return;
    }
    
    const qty_price = get_total_price * qty;       
    if(plan == 1){

      // console.log("qty_price dynamic",qty_price)
      const set_total_price = document.querySelectorAll(".discount_price");
       set_total_price?.forEach(el => {
        el.closest(".discount_wrapp")?.classList.remove("hide");
          console.log("product_price",product_price,product_qty_price,"get_total_price",get_total_price,qty_price)
          if(product_qty_price == qty_price){
            el.closest(".discount_wrapp")?.classList.add("hide");
          }
        el.innerHTML="";
        el.innerHTML = `${currency.formatMoney(product_qty_price)}`;
      });                  
      
       price_set?.forEach(el => {
        el.innerHTML=""
        el.innerHTML=`${currency.formatMoney(qty_price)}`;          
      });
    }

      price_set?.forEach(el => {
        el.innerHTML=""
        el.innerHTML=`${currency.formatMoney(qty_price)}`;          
      });
    // console.log("qty % 2 ",qty % 2 )
    // if (plan === 2 && qty % 2 !== 0) {
    //   console.log("plan 2",plan);
    //   // plusBtn?.click();
    // }else if(plan === 1 && qty % 2 === 0){    
    //   console.log("plan 1",plan);
    //   // minusBtn?.click();
    // }
    
    
  });
});

// window.chooseSubcription = function (qty_input) {
//   const qty = parseInt(qty_input.value || qty_input, 10);
//   const radios = document.querySelectorAll(".hdt-custom-subscription-box .purchase_option");
//   if (radios.length < 2) return;
//   if (qty % 2 !== 0) { 
//     console.log("qty",qty,"radio",radios[0]);   
//     radios[0].checked = true;
//     radios[0].dispatchEvent(new Event("change", { bubbles: true }));
//     console.log("radio",radios[0]);   
//   } else {    
//     console.log("qty else",qty,"radio",radios[1]);   
//     radios[1].checked = true;
//     radios[1].dispatchEvent(new Event("change", { bubbles: true }));
//     console.log("radio",radios[1]);   
//   }
// };
window.chooseSubcription = function (qty_input) {
  const qty = parseInt(qty_input.value);

  document.querySelectorAll(".hdt-custom-subscription-box").forEach(box => {
    const radios = box.querySelectorAll(".purchase_option");
     const checkedRadio = box.querySelector(".purchase_option:checked");
     const plan = checkedRadio.getAttribute("data-plan-sub");     
     console.log("radios[1]",radios[1],"radios.length",radios.length)
        if(radios[1].getAttribute("data-plan-sub") == "3") return;
        // if (radios.length <= 2) return;  
      const selectedRadio = qty % 2 !== 0 ? radios[0] : radios[1];
  
      if(qty % 2 !== 0 && plan == "3" ) return;
      // selectedRadio.checked = true;
      // selectedRadio.dispatchEvent(new Event("change", { bubbles: true }));

    //  } 
  });
};

// subscription on sticky bar
document.querySelectorAll('.custom-subscription-dropdown__toggle').forEach(button => {
  button.addEventListener('click', () => {
    const dropdown = button.closest('.custom-subscription-dropdown');
    const isOpen = dropdown.classList.toggle('open');
    button.setAttribute('aria-expanded', isOpen);
  });
});

document.querySelectorAll("input[name='selling_plan_sticky']").forEach(input => {
  input.addEventListener("change", () => {    
    // const get_plan = input.getAttribute("data-plan") || null;   
    const get_plan = input.id || null;   
    if(get_plan != null){
      // const check_same = document.querySelector(`.hdt-product__info-wrapp.product-info [data-plan="${get_plan}"]`  );    
      const check_same = document.querySelector(`.hdt-product__info-wrapp.product-info .purchase_option[id="${get_plan}"]`);    
      check_same?.click(); // optional
    }
  });
});


  // faq tabs toggal content start
    function tab_mai_mappert(item) {
      item.addEventListener("click", () => {
        const parent = item.closest(".hdt-main-faq-block");
         parent.querySelectorAll("[data-hendles]").forEach(tab => {
          const parent  = tab.closest("[horizon-tab-data]");          
          const parent_drop = tab.closest(".sub_tab_button-inner");
          const main_parent = tab.closest(".hdt-main-faq-block");
          const tabMobiles = main_parent.querySelector(".sub_tab_button-dropdown")            
          const text = item.innerText.trim();       
               
          if(tabMobiles) tabMobiles.innerText = text;    

            parent?.classList.remove("active");            
          });
        const parent_div  = item.closest("[horizon-tab-data]")?.classList.add("active");        
         toggal_all_tabs_content(item);
      });        
    }
    function toggal_all_tabs_content(item){
      const parent = item.closest(".hdt-main-faq-block");
      const tabs_data = item.getAttribute('data-hendles');
      let tabs_content_toggel = parent.querySelectorAll("[data-hendles-content]");

       

      tabs_content_toggel.forEach(b => {
        const content = b.getAttribute('data-hendles-content');
            if(content == tabs_data){
                b.classList.add("active");
                b.style.display = 'block';
            }else{
                b.classList.remove("active");
                  b.style.display = 'none';
            }
          });

          const parent_slider = parent.closest(".hdt-tab-panel.swiper")?.swiper || false;
      if(parent_slider){
         parent_slider.updateAutoHeight(500);
         parent_slider.productSwiper.update();

      }

    }
    let tabs_contents  = document.querySelectorAll("[data-hendles]");
    tabs_contents.forEach(tab_mai_mappert);



// horizon-tab -faq    
const get_wrapp_main = document.querySelectorAll("[sub-tab-button]");
get_wrapp_main.forEach(main => {
  const parent = main.closest(".hdt-main-faq-block");
  const thumbs = parent?.querySelectorAll("[horizon-tab-data]");

  if (thumbs?.length) {    
    const wrapper = document.createElement("div");
    wrapper.classList.add("sub_tab_button-inner");   
    //  wrapper.setAttribute("onclick", "this.classList.add('open')"); 
     wrapper.onclick = function() {
                    customdropdowntoggal(this);
                };
    main.append(wrapper);    
    thumbs.forEach(thumb => {
      wrapper.append(thumb);
    });
  }
});

const parent_tabs = document.querySelectorAll(".hdt-container--faqs");
// console.log("parent_tabs",parent_tabs.length)
parent_tabs.forEach(parent_tab => {
  const first_val = parent_tab?.querySelector("[data-hendles]");  
  // console.log("first_val",first_val)
  // first_val.click();
});

